import { z } from '@hono/zod-openapi'
import { zSelectVoucher } from './voucher.zod'

export const zVoucherWithRelations = zSelectVoucher.extend({
    benefitTitle: z.string().nullable(),
    benefitDescription: z.string().nullable(),
    vendorName: z.string().nullable(),
    vendorLogoUrl: z.string().nullable(),
    categoryName: z.string().nullable(),
})

export const zVoucherWithEmployeeInfo = zSelectVoucher.extend({
    benefitTitle: z.string().nullable(),
    vendorName: z.string().nullable(),
    employeeFirstName: z.string().nullable(),
    employeeLastName: z.string().nullable(),
    employeeEmail: z.string().nullable(),
    clientName: z.string().nullable(),
})

export type VoucherWithRelations = z.infer<typeof zVoucherWithRelations>
export type VoucherWithEmployeeInfo = z.infer<typeof zVoucherWithEmployeeInfo>
